import { render, staticRenderFns } from "./cbdw_list.vue?vue&type=template&id=aa8b32ec&scoped=true&"
import script from "./cbdw_list.vue?vue&type=script&lang=js&"
export * from "./cbdw_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8b32ec",
  null
  
)

export default component.exports